<template>
  <div class="user-box">
    <div class="user-sidebar">
      <div class="user-sidebar-title">
        <img src="@/assets/icon_user_title.png">
        <span>欢迎参赛</span>
      </div>
      <div class="user-menu">
        <div class="user-li" @click="goInfo()">
          <img src="@/assets/icon_user_info_unselect.png">
          <span>个人信息</span>
        </div>
        <div class="user-li" @click="goWork()">
          <img src="@/assets/icon_user_work_unselect.png">
          <span>作品管理</span>
        </div>
        <div class="user-li menu-activate">
          <img src="@/assets/icon_user_cert_selected.png">
          <span>证书查询</span>
        </div>
      </div>
    </div>
    <div class="user-content">
      <div class="user-avatar-box">
        <div class="user-avatar">
          <label for="def_input">
            <img :src="avatar || require('@/assets/default_av.png')" alt=" ">
          </label>
          <input type="file" accept="image/*" hidden id="def_input" @change="getFile">
        </div>
        <span>{{ realname }}</span>
      </div>

      <div class="input-module-box">
        <template v-if="this.awardList.length > 0">
          <div class="cert-list">
            <div class="table-line">
              <div class="table-cell table-cell-group">赛道</div>
              <div class="table-cell table-cell-topic">主题</div>
              <div class="table-cell table-cell-prize">奖项</div>
              <div class="table-cell table-cell-certificate-no">证书编号</div>
              <div class="table-cell table-cell-works">作品</div>
              <div class="table-cell table-cell-certificate-download">获奖证书</div>
            </div>
            <template v-for="(item) in awardList">
              <div class="table-line table-content" :key="item.id">
                <div class="table-cell table-cell-group table-cell-content">{{item.raceStr}}</div>
                <div class="table-cell table-cell-topic table-cell-content">{{item.topicStr}}</div>
                <div class="table-cell table-cell-prize table-cell-content">{{item.prizeStr}}</div>
                <div class="table-cell table-cell-certificate-no table-cell-content">{{item.certificate_no}}</div>
                <div class="table-cell table-cell-works table-cell-content">{{item.title}}</div>
                <!--
                <div class="table-cell table-cell-certificate-download table-cell-content">

                </div>-->
                <div class="table-cell table-cell-certificate-download table-cell-content" @click="download(item.id,item.certificate_no)">
                  <span>下载</span>
                  <img :src="require('@/assets/user_certificate_download_icon.png')">
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="cert-list">
            <div class="cert-msg">暂无数据</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {Warning} from "@/plugins/warning";
import {getAwardList,updateAv,getUserInfo} from "../../request/api";
import $ from "jquery";
import OSS from "ali-oss";
export default {
  name: "accountManage",
  components:{
  },
  data() {
    return {
      avatar: '',
      realname: '', //用户名
      awardList : []
    }
  },
  computed: {
    ...mapGetters('infoModule',['getUserInfoObj']),
  },
  created() {
    this.getAwardList();
    this.getUserInfo();
  },
  mounted() {
  },
  methods: {
    getUserInfo(){
      getUserInfo({}).then((res)=>{
        this.avatar = res.data.avatar;
        this.realname = res.data.realname;
      })
    },
    getAwardList(){
      const requestData = {
        "type":"personal"
      }
      getAwardList(requestData).then((res)=>{
        this.awardList = res.data.award;
      })
    },
    download(certificate_id,certificate_no){
      let url = process.env.VUE_APP_SERVER_URL+"/works/award/download?id="+certificate_id+"&certificateNo="+certificate_no;
      window.open(url, '_blank');
    },
    goInfo(){
      this.$router.push({name:'userAccountManage'})
    },
    goWork(){
      this.$router.push({name:'userWorks'})
    },
    goCert(){
      this.$router.push({name:'userCertificate'})
    },
    getFile(e){
      const that = this;
      const file = e.target.value;
      let filename=file.replace(/.*(\/|\\)/, "");
      let fileExt=(/[.]/.exec(filename)) ? /[^.]+$/.exec(filename.toLowerCase()) : '';
      let storage = JSON.parse(window.localStorage.getItem('STORAGE'));
      $.ajax({
        url: process.env.VUE_APP_SERVER_URL+'/works/uploads/index',
        data:{
          suffix:fileExt[0],
          path:"avatar"
        },
        headers:{
          Authorization:storage.infoModule.token
        },
        async: true,
        global: false,
        type: 'POST',
        dataType: 'json',
        timeout:1000*7,
        success: function(data) {
          if (data.status === 200) {
            const client = new OSS({
              region: data.result.data.region,
              accessKeyId: data.result.data.access_key_id,
              accessKeySecret: data.result.data.access_key_secret,
              stsToken: data.result.data.security_token,
              bucket: data.result.data.bucket,
            });

            client.multipartUpload(data.result.data.key, e.target.files[0], {
              // 设置上传回调。
              progress:(p) => {
                if(p>=1){
                  updateAv({avatar:data.result.data.url}).then(()=>{
                    that.$store.dispatch('infoModule/getUserInfo')
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000)
                  })
                }
              }
            });
          }else {
            Warning.open(data.msg);
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.user-box{
  width: 1280px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  padding-bottom: 200px;
  background: #F6F6F6;
  display: flex;
  .user-sidebar{
    width: 320px;
    height: 560px;
    background: #fff;
    //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .user-sidebar-title{
      width: 260px;
      height: 56px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 50px;
      img{
        width: 56px;
        height: 56px;
        float: left;
      }
      span{
        font-size: 24px;
        font-weight: 500 ;
        color: #FF3B30;
        height: 56px;
        line-height: 56px;
        float: left;
        margin-left: 20px;
      }
    }
    .user-menu{
      width: 260px;
      height: 340px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 50px;
      .user-li{
        float: left;
        width: 260px;
        height: 65px;
        margin-bottom: 30px;
        background-color: #FFF;
        cursor: pointer;
        img{
          width: 32px;
          height: 32px;
          float: left;
          margin-left: 25px;
          margin-top: 16px
        }
        span{
          font-size: 20px;
          font-weight: 400;
          color: #696969;
          height: 65px;
          line-height: 65px;
          float: left;
          margin-left: 20px;
        }
      }
      .menu-activate{
        background-color: #FF3B30;
        span{
          color: #FFF;
        }
      }
    }
  }
  .user-content{
    width: 930px;
    height: 870px;
    margin-left: 35px;
    background: #fff;
    //box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    .user-avatar-box{
      width: 95px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 30px;
      .user-avatar{
        height: 95px;
        width: 95px;
        background: url(~@/assets/user_avatar_bg.png);
        background-size: cover;
        img{
          margin-top: 10px;
          margin-left: 10px;
          height: 72px;
          width: 72px;
          border-radius: 50%;
          overflow: hidden;
          cursor: pointer;
        }
      }
      span{
        font-size: 20px;
        font-weight: 400;
        color: #3F3F3F;
        height: 29px;
        line-height: 29px;
        text-align: center;
        display: block;
        margin-top: 10px;
      }
    }
    .input-module-box{
      width: 800px;
      margin-left: auto;
      margin-right: auto;
      .table-line{
          width: 100%;
          height: 50px;
          border-bottom: #ddd 1px solid;
          .table-cell{
            float: left;
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        .table-cell-group{
          width: 100px;
        }
        .table-cell-topic{
          width: 100px;
        }
        .table-cell-prize{
          width: 100px;
        }
        .table-cell-certificate-no{
          width: 150px;
        }
        .table-cell-works{
          width: 250px;
        }
        .table-cell-certificate-download{
          width: 100px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            width: 30px;
            height: 30px;
          }
        }
      }
      .cert-msg{
        width: 100%;
        height: 200px;
        line-height: 200px;
        color: #939393;
        text-align: center;
      }
    }
  }
}
</style>
